import React, { useLayoutEffect, useState, useEffect } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
    LoadPanel, MasterDetail
} from "devextreme-react/data-grid";
import { Button, DateBox, SelectBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { FundRequestService } from '../../../apis/apiServices/FundRequest';
import { ProjectService } from '../../../apis/apiServices/Project'
import Modal from "react-modal";
import PaymentDetailsModal from '../../common/Modal/PaymentDetailsModal';

export default function FundRequestReportComponent(props) {

    useLayoutEffect(() => {
        document.querySelector("#pageTitle").innerHTML = "FR - Fund Request Report";
        getFundRequestList();
        getProjectDropdownData();
    }, []);
    const navigate = useNavigate();
    const [projectDropdownData, setProjectDropdownData] = useState(null);
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: 0,
        statusId: 0,
        requestNo: 0,
    });
    const [paymentDeatilsSrno, setPaymentDetailsSrno] = useState(null);
    const [filterErrors, setFilterErrors] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const [isitemDetailsModalVisible, setIsitemDetailsModalVisible] = useState(false);
    const [paymentDeatilsByPrId, setPaymentDetailsByPrId] = useState(null);
    const [loading, setLoading] = useState(false);
    const user = useSelector((state) => state.user.data);
    const [fundRequestList, setFundRequestList] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const ConvertDateToddMMyyyy = (date) => {
        if (!date) return "";
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }


    const getFundRequestList = async (isIgnoreFilters) => {
        try {
            setLoading(true);
            // let body = {
            //     UserId: user?.userId,
            //     fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
            //     toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
            //     FundRequestId: (filters?.requestNo && isIgnoreFilters !== true) ? filters?.requestNo : 0,
            //     projectId: (filters?.projectId && isIgnoreFilters !== true) ? filters?.projectId : 0,
            //     StatusId: (filters?.statusId && isIgnoreFilters !== true) ? filters?.statusId : 0,
            // }

            let body = {
                UserId: user?.userId,
                fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
                toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
                FundRequestId: (filters?.requestNo && isIgnoreFilters !== true) ? filters?.requestNo : 0,
                projectId: (filters?.projectId && isIgnoreFilters !== true) ? filters?.projectId : 0,
                //StatusId: 1,
                requestStatusId: 13,
            }
            setLoading(true);
            const response = await FundRequestService.getFundRequestList(body)
            setLoading(false);
            setFundRequestList(response?.data);
            return response?.data;
        } catch (error) {
            console.log("Error getFundRequestList===>", error);
        }
    }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }

    const closeModal = () => {

        setIsitemDetailsModalVisible(false);

    };

    const calculateCellValue2 = (dateValue) => {
        if (!dateValue) return "";
        const d = new Date(dateValue);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleFilterChange = (key, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }
    const getPaymentDeatilsByPrItemId = async (fundRequestId, vendorId, vendorBankId, serialNo) => {
        const data = { fundRequestId: fundRequestId, vendorId: vendorId, vendorBankId: vendorBankId }
        try {
            const response = await FundRequestService.getFundRequestitemPaymentDetailsByFrIdVendorIdVendorBankId(data)


            const paymentSrNo = { paymentRequestId: response?.data, itemSerialNo: serialNo }
            setPaymentDetailsByPrId(response?.data, serialNo);
            setPaymentDetailsSrno(serialNo)

            setIsitemDetailsModalVisible(true)
        } catch (error) {
            console.log("Error getPaymentDeatilsByPrItemId===>", error);
        }
    }
    // useEffect(() => {
    //     getFundRequestList();
    // })

    const renderDetail = (detailData) => {
        const { data } = detailData; // parent row data

        return (
            <DataGrid
                dataSource={data?.items || []}  // <-- children list for this parent
                columnAutoWidth
                showBorders
                showRowLines
                showColumnLines={false}
                noDataText="No details"
            >
                <Column dataField="itemSerialNo" caption="Serial No." />
                <Column dataField="vendorName" caption="Vendor" />
                {/* <Column dataField="location" caption="Location" /> */}
                <Column dataField="bankName" caption="Bank"
                    cellRender={(e) => (
                        <div>
                            <div>{e.data.bankName}</div>
                            <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.branchName}</div>
                        </div>
                    )}
                />
                {/* <Column dataField="itemStatus" caption="Status" /> */}
                {/* <Column dataField="balanceAmt" caption="Ledger Balance" allowFiltering={false} allowSearch={true} /> */}
                <Column dataField="recommendedAmt" caption="Recommended Amt." allowFiltering={false} allowSearch={true} />
                <Column dataField="paidAmt" caption="Paid Amt." allowFiltering={false} allowSearch={true} />
                {/* <Column
                    dataField="paymentDate"
                    caption="Payment Date"
                    width="150px"
                    allowFiltering={false}
                    allowSearch={true}
                    calculateCellValue={(cellData) => {
                        const date = new Date(cellData?.paymentDate);
                        return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`
                    }}
                    cellRender={(e) => {
                        const date = new Date(e.data.paymentDate);
                        return (
                            <>
                                <div>
                                    {date.toLocaleDateString('en-GB')}&nbsp;
                                    {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                    <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data?.fromUser}</div>
                                </div>
                            </>
                        );
                    }}
                /> */}

                <Column dataField="advPaymentRequestId" caption="Advance Request Id" allowEditing={false} width={150} />

                <Column
                    dataField=""
                    caption="Payment Status"
                    cellRender={(e) => (
                        <div style={{ textAlign: "center" }}>
                            {(e.data?.paidAmt > 0) ? (
                                <div>
                                    <Icon
                                        icon="material-symbols:check-circle-outline-rounded"
                                        title="Payment Done"
                                        style={{ color: "green", fontSize: "20px", cursor: 'pointer' }}
                                        onClick={() => getPaymentDeatilsByPrItemId(e.data?.fundRequestId, e.data?.vendorId, e.data?.vendorBankId, e.data?.itemSerialNo)}
                                    // onClick={() => { setIsitemDetailsModalVisible(true) }}

                                    />
                                    <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.paymentDate
                                        ? new Date(e.data.paymentDate)
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, "-")
                                        : ""}</div>
                                </div>

                            ) : (
                                <Icon
                                    icon="mdi:clock-outline"
                                    title="Pending Payment"
                                    style={{ color: "gray", fontSize: "20px", opacity: 0.5 }}
                                />
                            )}
                        </div>
                    )}
                />
            </DataGrid>
        );
    };

    return (
        <>
            <div className="content">
                {/* Filters */}
                <div className="card filter">
                    <div className="card-body">
                        <div className="row">
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    From
                                </label>
                                <DateBox
                                    placeholder="Select date"
                                    value={filters?.fromDate}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("fromDate", e?.value)
                                    }
                                    }
                                    displayFormat="dd/MM/yyyy"
                                />
                                {filterErrors?.fromDate && <span className="error invalid-feedback">{filterErrors?.fromDate}</span>}
                            </div>
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    To
                                </label>
                                <DateBox
                                    placeholder="Select date"
                                    value={filters?.toDate}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("toDate", e?.value)
                                    }}
                                    displayFormat="dd/MM/yyyy"
                                />
                                {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>}
                            </div>
                            {/* <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    Status <span className="text-danger"></span>
                                </label>
                                <SelectBox
                                    //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                    //dataSource={iomStatusDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select status"
                                    searchEnabled
                                    showClearButton={false}
                                    value={filters?.statusId}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("statusId", e?.value)
                                    }}
                                />
                            </div> */}
                            {/* <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    Request No.<span className="text-danger"></span>
                                </label>
                                <SelectBox
                                    //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                    //dataSource={requestNoDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select request no."
                                    searchEnabled
                                    showClearButton={false}
                                    value={filters?.requestNo}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("requestNo", e?.value)
                                    }}
                                />
                            </div> */}
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label>
                                    Project <span className="text-danger"></span>
                                </label>
                                <SelectBox
                                    dataSource={projectDropdownData}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select project"
                                    searchEnabled
                                    showClearButton={false}
                                    value={filters?.projectId}
                                    onValueChanged={(e) => {
                                        e?.value && handleFilterChange("projectId", e?.value)
                                    }}
                                />
                            </div>
                            <div className='col-lg-2 col-md-3 col-sm-12'>
                                <label style={{ display: "block" }}>&nbsp;</label>
                                <button
                                    className="btn btn-primary btn-sm mt-2 mr-2"
                                    title='Filter'
                                    tooltip='Filter'
                                    onClick={getFundRequestList}
                                >
                                    <Icon className='iconify-size mr-1' icon="hugeicons:filter" />
                                    Filter
                                </button>
                                <button
                                    className="btn btn-outline-primary btn-sm mt-2"
                                    title='Clear'
                                    tooltip='Clear'
                                    onClick={() => {
                                        setFilters(prevState => {
                                            return {
                                                ...prevState,
                                                fromDate: "",
                                                toDate: "",
                                                projectId: 0,
                                                statusId: 0,
                                                requestNo: 0,
                                            }
                                        })
                                        getFundRequestList(true);
                                    }}
                                >
                                    <Icon className='iconify-size mr-1' icon="hugeicons:eraser" />
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <div className='card-body'>
                        <DataGrid
                            dataSource={fundRequestList}
                            className='iom-grid grd-payment-request'
                            columnAutoWidth
                            showBorders
                            showColumnLines={false}
                            showRowLines={true}
                            allowFiltering
                            columnHidingEnabled
                            onToolbarPreparing={(e) => {
                                e.toolbarOptions.items.unshift({
                                    location: "before",
                                    widget: "dxButton",
                                    options: {
                                        icon: "refresh",
                                        text: "Refresh",
                                        type: "default",
                                        stylingMode: "outlined",
                                        onClick: () => getFundRequestList(),
                                        hint: "Refresh",
                                    }
                                });
                                e.toolbarOptions.items.unshift({
                                    location: "before",
                                    widget: "dxButton",
                                    visible: (props?.isAllowedForThisRole || props?.featurePermission?.canAdd) ? true : false,
                                    options: {
                                        icon: "plus",
                                        text: "New",
                                        type: "default",
                                        stylingMode: "contained",
                                        onClick: () => navigate("/new-fund-request"),
                                        hint: "New Fund Request",
                                    }
                                });
                            }}
                        >
                            <Column
                                width="95px"
                                cellRender={(cellData) => {
                                    const rowData = cellData?.data;
                                    return (
                                        <>
                                            {/* View */}
                                            <span title='View'>
                                                <Icon
                                                    title="View"
                                                    className='iconify-size mr-1'
                                                    icon="solar:document-text-outline"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                        navigate("/view-fund-request", { state: { fundRequestId: rowData?.fundRequestId } })
                                                    }
                                                />
                                            </span>
                                            {/* Edit */}
                                            {((rowData?.createdByUserId === user?.userId && rowData?.iomStatusId === 4) ||
                                                rowData?.iomStatusId === 8 || rowData?.iomStatusId === 5) ? (
                                                <span title="Edit">
                                                    <Icon
                                                        title="Edit"
                                                        className='iconify-size mr-1'
                                                        icon="solar:pen-line-duotone"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() =>
                                                            navigate(
                                                                rowData?.isManual
                                                                    ? "/new-inter-office-memo-old"
                                                                    : "/new-inter-office-memo",
                                                                { state: rowData }
                                                            )
                                                        }
                                                    />
                                                </span>
                                            ) : (
                                                <span>
                                                    <Icon
                                                        title="Edit"
                                                        className='iconify-size'
                                                        icon="solar:pen-line-duotone"
                                                        style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                    />
                                                </span>
                                            )}
                                            {/* Delete */}
                                            {rowData?.createdByUserId === user?.userId && (rowData?.iomStatusId === 8 || rowData?.iomStatusId === 4) ? (
                                                <span title="Delete">
                                                    <Icon
                                                        title="Delete"
                                                        className='iconify-size'
                                                        icon="fluent:delete-32-regular"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            //setIOMId(rowData?.iomId);
                                                            //setIsDeleteModalVisible(true);
                                                        }}
                                                    />
                                                </span>
                                            ) : (
                                                <span>
                                                    <Icon
                                                        title="Delete"
                                                        className='iconify-size'
                                                        icon="fluent:delete-32-regular"
                                                        style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                    />
                                                </span>
                                            )}

                                        </>
                                    );
                                }}
                            />
                            <Column dataField="projectName" caption="Project" allowFiltering={false} allowSearch={true} />
                            <Column dataField="departmentName" caption="Department" allowFiltering={false} allowSearch={true} />
                            <Column dataField="serialNo" allowSearch={true} caption="Request No." width='250px' allowFiltering={false} />
                            <Column
                                caption="From"
                                allowSearch={true}
                                calculateCellValue={(cellData) => `${cellData?.fromUser || ""} ${cellData?.fromUserDepartment || ""}`}
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data?.createdBy}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.createdByDepartment}</div>
                                    </div>
                                )}
                            />
                            <Column
                                caption="To"
                                allowSearch={true}
                                calculateCellValue={(cellData) => `${cellData?.finalApprovedBy || ""} ${cellData?.finalApproverDepartment || ""}`}
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data?.finalApprovedBy}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.finalApproverDepartment}</div>
                                    </div>
                                )}
                            />
                            {/* <Column dataField="requestStatus" caption="Status" allowFiltering={false} allowSearch={true} /> */}
                            <Column
                                // dataField="nextUserStatusText"
                                caption="Status"
                                allowSearch={true}
                                calculateCellValue={(cellData) => `${cellData?.requestStatusId === 8 ? "Drafted"
                                    : cellData?.requestStatusId === 4 ? "Revised Draft"
                                        : cellData?.nextUserStatusText ?? "Approved"
                                    }
                                ${cellData?.nextUser?.trim() === "" ? cellData?.lastUpdatedByUser : cellData?.nextUser}
                                `

                                }
                                cellRender={(e) => {
                                    let color = '#28A745';
                                    if (e.data?.requestStatusId === 4) color = 'gray';
                                    else if (e.data?.requestStatusId === 1) color = '#28A745';
                                    else if (e.data?.requestStatusId === 2) color = '#FF9800';
                                    else if (e.data?.requestStatusId === 3) color = 'orange';
                                    else if (e.data?.requestStatusId === 7) color = '#ff9800';
                                    else if (e.data?.requestStatusId === 11) color = '#ff9800';
                                    return (
                                        <div>
                                            {(e.data?.requestStatusId === 8) ? (
                                                <span style={{ color: '#6C757D' }}>Drafted</span>
                                            ) : (e.data?.requestStatusId === 4) ? (
                                                <span style={{ color: '#DC3545' }}>Revised Draft</span>
                                            ) : (e.data?.requestStatusId === 9) ? (
                                                <span style={{ color: '#DC3545' }}>Recall Requested</span>
                                            ) : (e.data?.requestStatusId === 11) ? (
                                                <span style={{ color: '#ff9800' }}>{e?.data?.requestStatus}</span>
                                            ) : (
                                                <span style={{ color }}>{e?.data?.nextUserStatusText ?? e?.data?.requestStatus}</span>
                                            )}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                                                {e.data?.nextUser?.trim() === "" ? e.data?.lastUpdatedByUser : e.data?.nextUser}
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                            {/* <Column dataField="totalBalanceAmt" caption="Ledger Balance" allowFiltering={false} allowSearch={true} /> */}
                            <Column dataField="totalRecommendedAmt" caption="Total Recommended Amt." allowFiltering={false} allowSearch={true} />
                            <Column dataField="totalPaidAmt" caption="Total Paid Amt." allowFiltering={false} allowSearch={true} />
                            <Column
                                dataField="createdOn"
                                caption="Created On"
                                width="150px"
                                allowFiltering={false}
                                allowSearch={true}
                                calculateCellValue={(cellData) => {
                                    const date = new Date(cellData?.createdOn);
                                    return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`
                                }}
                                cellRender={(e) => {
                                    const date = new Date(e.data.createdOn);
                                    return (
                                        <>
                                            <div>
                                                {date.toLocaleDateString('en-GB')}&nbsp;
                                                {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                                <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data?.fromUser}</div>
                                            </div>
                                        </>
                                    );
                                }}
                            />
                            <Column
                                dataField="lastUpdatedOn"
                                caption="Last Updated"
                                allowFiltering={false}
                                width="150px"
                                allowSearch={true}
                                calculateCellValue={(cellData) => {
                                    const date = new Date(cellData?.lastUpdatedOn);
                                    return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                ${cellData?.lastUpdatedByUser}`
                                }}
                                cellRender={(e) => {
                                    // if (!e.data.lastUpdatedOn) return null;
                                    // const date = new Date(e.data.lastUpdatedOn);
                                    if (!e.data.history[0]?.updatedOn) return null;
                                    const date = new Date(e.data.history[0]?.updatedOn);
                                    return (
                                        <div>
                                            {date.toLocaleDateString('en-GB')}&nbsp;
                                            {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data.lastUpdatedByUser}</div>
                                        </div>
                                    );
                                }}
                            />
                            {/* Master Detail */}
                            <MasterDetail enabled={true} render={renderDetail} />
                            <HeaderFilter visible={true} />
                            <LoadPanel
                                //shadingColor="rgba(179, 34, 34, 0.4)"
                                //position={position}
                                visible={loading}
                                showIndicator={true}
                                //shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <SearchPanel
                                visible={true}
                                highlightCaseSensitive={false}
                                highlightSearchText={true}
                                width={240}
                                placeholder="Search..."
                            />
                            <LoadPanel
                                //shadingColor="rgba(179, 34, 34, 0.4)"
                                //position={position}
                                visible={loading}
                                showIndicator={true}
                                //shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <Paging defaultPageSize={15} />
                            <Pager
                                visible={true}
                                allowedPageSizes={[10, 15, 20, 50, 100]}
                                showPageSizeSelector={true}
                                showInfo={true}
                                showNavigationButtons={true}
                            />
                            <Export enabled={false} fileName="Fund Request" />
                        </DataGrid>
                    </div>
                </div>
            </div>

            {/* Payment deails Modal */}

            <PaymentDetailsModal paymentDeatilsByPrId={paymentDeatilsByPrId} paymentDeatilsSrno={paymentDeatilsSrno} closeModal={closeModal} isitemDetailsModalVisible={isitemDetailsModalVisible} isSubmitted={isSubmitted} title="Fund Request Details" />

        </>
    )
}
